module.exports = __webpack_public_path__ + "static/img/keep_benefit_viproom_display.66ac4931.png";